import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';




import { ChatPanelModule } from 'app/layout/components/chat-panel/chat-panel.module';


import { NavbarModule } from 'app/layout/components/navbar/navbar.module';


import { VerticalLayout1Component } from 'app/layout/vertical/layout-1/layout-1.component';

@NgModule({
    imports: [
    RouterModule,
    ChatPanelModule,
    NavbarModule,
    VerticalLayout1Component,
],
    exports: [
        VerticalLayout1Component
    ]
})
export class VerticalLayout1Module
{
}
